const initialState = {
  id: null,
  name: null,
  email: null,
  userName: null,
  role: null,
  token: null,
};

const loginReducer = (state = initialState, action) => {
  switch (action.type) {
    case "user/login":
      return {
        ...state,
        id: action.payload.id,
        name: action.payload.name,
        email: action.payload.email,
        userName: action.payload.name,
        role: action.payload.role,
        token: action.payload.token,
      };
    default:
      return state;
  }
};

export default loginReducer;
